package nl.volleyplanner.api

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class PersonActivity(
    val startDateTime: LocalDateTime?,
    val endDateTime: LocalDateTime?,
    val activityType: String,
    val description: String,
    val activityContext: Map<String, String> = emptyMap()
)